import { useState } from "react";
import { Check } from "../../components/Check/Check";
import { useDispatch, useSelector } from "react-redux";
import { RootStore } from "../../state/store";
import { useNavigate } from "react-router-dom";
import { SET_SETTINGS } from "../../state/reducers/settings";
import { Grid } from "@mui/material";

interface SKSettingsProps {
  onGoBack: () => void;
}
export function SKSettings(props: SKSettingsProps) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const settings = useSelector((state: RootStore) => state.settings);
  const material = useSelector((state: RootStore) => state.material);
  const [editedSettings, setEditedSettings] = useState(settings);

  return (
    <div className="main-box" style={{ marginTop: 10 }}>
      <h2>Scorekeeper Settings</h2>
      <Check
        checked={editedSettings.skAdvanced}
        onClick={(e) => setEditedSettings({ ...editedSettings, skAdvanced: e })}
      >
        Advanced Mode
      </Check>
      <p style={{ fontSize: 12, marginTop: -2 }}>
        Will give you more options and stats, but will be slightly more
        difficult to keep score.
      </p>
      <Check
        checked={editedSettings.skIncludeOvertime}
        onClick={(value: boolean) =>
          setEditedSettings({ ...editedSettings, skIncludeOvertime: value })
        }
      >
        Include Overtime in Stats
      </Check>
      <p style={{ fontSize: 12, marginTop: -2 }}>
        You can change this in any Settings view, but this option will set the
        default.
      </p>

      {/* <Check
          checked={editedSettings.skDisableGraphs}
          onClick={(value: boolean) =>
            setEditedSettings({ ...editedSettings, skDisableGraphs: value })
          }
        >
          Disable Graphs
        </Check>
        <p style={{ fontSize: 12, marginTop: -2 }}>
          Gives simpler views instead of line graphs
        </p> */}
      <Check
        checked={editedSettings.skCompact}
        onClick={(e: boolean) =>
          setEditedSettings({ ...editedSettings, skCompact: e })
        }
      >
        Compact View
      </Check>
      <p style={{ fontSize: 12, marginTop: -2 }}>Good for Phones</p>
      <hr className="separator-line" />
      <h2>Books</h2>
      <p>
        Select which books you want to be included for verse selection. If you
        don't select any books, the current BQF year's books will be used.
      </p>
      <Grid container spacing={1}>
        {material.material.map((book, index) => (
          <Grid key={book.bookName}>
            <Check
              checked={editedSettings.selectedSKBooks[index]}
              style={{ width: 180 }}
              onClick={(value) => {
                const newBooks = [...editedSettings.selectedSKBooks];
                newBooks[index] = value;
                setEditedSettings({
                  ...editedSettings,
                  selectedSKBooks: newBooks,
                });
              }}
            >
              {book.bookName}
            </Check>
          </Grid>
        ))}
      </Grid>
      <hr className="separator-line" />
      <button
        className="link"
        onClick={() => {
          dispatch({ type: SET_SETTINGS, payload: editedSettings });
          navigate("/sk/hotkeys");
          window.scrollTo(0, 0);
        }}
      >
        Edit Scorekeeper Hotkeys
      </button>
      <br />
      <br />
      <button
        className="clickable"
        onClick={() => {
          dispatch({ type: SET_SETTINGS, payload: editedSettings });
          props.onGoBack();
        }}
      >
        Save Settings
      </button>
    </div>
  );
}
